module.exports = "/packs/images/svg/facilities/physio_clinic_v2~6338338c1f7b87a2648dbab36cbd2330.svg";